<ng-container *transloco="let translate">
  <div fxFlex="100" fxLayoutAlign="flex-start start" fxLayoutGap="12px">
    @if (isAdmin) {
      <div fxLayout="row wrap" fxLayoutGap="6px">
        @for (quickFilter of quickFiltersList; track i; let i = $index) {
          <div class="pb-10">
            <button
              (click)="onFilterSelect(quickFilter, i)"
              [ngClass]="{ active: i === activeFilter }"
              egButton
              egStyle="secondary"
              egType="round"
              egButtonSize="small"
              type="button"
              [egTooltip]="quickFilter.name"
              [showToolTip]="isTextTruncated(filterLabel)"
              class="quick-filter--button"
            >
              <span #filterLabel class="quick-filter--label">{{ quickFilter.name }}</span>
            </button>
          </div>
        }
      </div>
    }

    <div fxFlex fxLayoutAlign="flex-end center" fxLayoutGap="10px" class="pb-10">
      @if (showSearch && isAdmin) {
        <button (click)="onSearch()" class="form-reset-button" egButton egType="round" type="submit" egButtonSize="small">
          {{ translate('support.button.search') }}
        </button>
      }
      <button (click)="onReset()" egStyle="secondary" class="form-reset-button" egButton egType="round" type="button" egButtonSize="small">
        {{ translate('support.button.reset') }}
      </button>
      @if (isAdmin) {
        <span (click)="quickFilter()" class="filter-btn mt-4">
          <img src="assets/icons/field_filter.svg" />
        </span>
      }
    </div>
  </div>
</ng-container>
